import React, { useEffect, useState } from 'react';
import { Button, Card, Form, Input, Space, Table, Modal, Popconfirm, Flex } from 'antd';
import StoreSettingService from "services/store_setting";
import { useApp } from 'contexts/app';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';

const service = new StoreSettingService();

const generateInternalStatusID = (items = []) => {
    const maxSuffix = items.reduce((acc, item) => {
        const match = String(item?.id ?? '').match(/^internal_status_(\d+)$/);
        if (!match) return acc;
        return Math.max(acc, Number(match[1]));
    }, 0);

    return `internal_status_${maxSuffix + 1}`;
}

const InternalStatusSettingPage = () => {
    const { showLoading, showNotify, message } = useApp();
    const [statuses, setStatuses] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [form] = Form.useForm();

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const data = await service.getOrderInternalStatuses();
        setStatuses(data ?? []);
    }

    const saveAll = async (nextStatuses) => {
        showLoading(true);
        await service.saveOrderInternalStatuses(nextStatuses);
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật");
    };

    const openAddModal = () => {
        setEditingIndex(-1);
        form.setFieldsValue({ title: "" });
        setIsModalOpen(true);
    }

    const openEditModal = (record, index) => {
        setEditingIndex(index);
        form.setFieldsValue({ title: record.title });
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
        setEditingIndex(-1);
        form.resetFields();
    }

    const submitModal = async () => {
        try {
            const values = await form.validateFields();
            const nextTitle = String(values.title ?? "").trim();

            if (!nextTitle) {
                message.error("Bạn phải nhập đầy đủ thông tin");
                return;
            }

            const next = [...statuses];
            if (editingIndex >= 0) {
                next[editingIndex] = { ...next[editingIndex], title: nextTitle };
            } else {
                next.push({
                    id: generateInternalStatusID(next),
                    title: nextTitle,
                });
            }

            await saveAll(next);
            closeModal();
        } catch (error) {
        }
    }

    const removeStatus = async (index) => {
        if (statuses.length <= 1) {
            message.error("Phải có ít nhất 1 trạng thái nội bộ");
            return;
        }
        const next = statuses.filter((_, idx) => idx !== index);
        await saveAll(next);
    }

    const columns = [
        {
            title: "Tên hiển thị",
            dataIndex: "title",
            key: "title"
        },
        {
            title: "",
            key: "actions",
            render: (_, record, index) => (
                <Space>
                    <Button type='link' onClick={() => openEditModal(record, index)}><EditOutlined /></Button>
                    <Popconfirm
                        title="Xoá trạng thái"
                        description="Bạn có chắc chắn muốn xoá trạng thái này?"
                        onConfirm={() => removeStatus(index)}
                        okText="Xoá"
                        cancelText="Huỷ"
                    >
                        <Button type='link' danger><DeleteOutlined /></Button>
                    </Popconfirm>
                </Space>
            )
        }
    ];

    return (
        <Card title="Cấu hình trạng thái nội bộ">
            <Space direction='vertical' style={{ width: "100%" }}>
                
                    <Flex justify='flex-end'>
                        <Button type="primary" onClick={openAddModal} icon={<PlusOutlined />}>
                            Thêm mới
                        </Button>
                    </Flex>

                

                <Table
                    rowKey={(record, index) => `${record.id}_${index}`}
                    dataSource={statuses}
                    columns={columns}
                    pagination={false}
                />


            </Space>

            <Modal
                title={editingIndex >= 0 ? "Chỉnh sửa trạng thái" : "Thêm trạng thái mới"}
                open={isModalOpen}
                onCancel={closeModal}
                onOk={submitModal}
                okText="Lưu"
                cancelText="Huỷ"
            >
                <Form form={form} layout='vertical'>
                    <Form.Item
                        label="Tên hiển thị"
                        name="title"
                        rules={[{ required: true, message: 'Nhập tên hiển thị' }]}
                    >
                        <Input placeholder="vd: Chờ đóng gói" />
                    </Form.Item>
                </Form>
            </Modal>
        </Card>
    )
}

export default InternalStatusSettingPage;
